<template>
  <div class="img">
    <el-popover placement="bottom" width="60" trigger="click" v-model="model">
      <div class="popoverRow" @click="goIndex">首页</div>
      <div class="popoverRow" @click="changePassword">修改密码</div>
      <div class="popoverRow" @click="goUser">档案中心</div>
      <div class="popoverRow" style="margin-bottom: 0" @click="settingNameFn">
        修改医生姓名
      </div>
      <img slot="reference" src="../assets/user.png" alt="" />
    </el-popover>
    <el-dialog
      :modal="false"
      title="修改医生姓名"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <el-input v-model="name"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="medium" @click="submit" style="background-color:rgba(2, 72, 167);border-color:rgba(2, 72, 167)"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <el-dialog title="修改密码" :visible.sync="dialogFormVisible" width="25%">
      <el-form :model="form" :rules="rules" ref="ruleForm">
        <el-form-item label="用户名" label-width="80px" prop="userName">
          <el-input v-model="form.userName" disabled></el-input>
        </el-form-item>
        <el-form-item label="新密码" label-width="80px" prop="userPassword">
          <el-input v-model="form.userPassword"></el-input>
        </el-form-item>
        <el-form-item
          label="确认密码"
          label-width="80px"
          prop="comfirmPassword"
        >
          <el-input v-model="form.comfirmPassword"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="dialogFormVisible = false"
          >取 消</el-button
        >
        <el-button size="medium" type="primary" style="background-color:rgba(2, 72, 167);border-color:rgba(2, 72, 167)" @click="comfirmChnagePassword"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import {
  settingName,
  getUserInfo,
  changePasswordRequest,
} from "../utils/login";
export default {
  name: "VuePortrait",
  data() {
    return {
      model: false,
      name: "",
      dialogVisible: false,
      dialogFormVisible: false,
      form: {
        userName: "",
        userPassword: "",
        comfirmPassword: "",
      },
      rules: {
        userName: [
          { required: true, message: "用户名不能为空", trigger: "blur" },
        ],
        userPassword: [
          { required: true, message: "新密码不能为空", trigger: "blur" },
        ],
        comfirmPassword: [
          { required: true, message: "确认密码不能为空", trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  mounted() {
    this.form.userName = this.userInfo.userName;
    this.name = this.userInfo.doctorName;
  },
  methods: {
    changePassword() {
      this.dialogFormVisible = true;
    },
    comfirmChnagePassword() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          if (this.form.comfirmPassword != this.form.userPassword) {
            this.$message({
              message: "两次输入的密码不一致！",
            });
            return;
          } else {
            let params = {
              id: this.userInfo.userId,
              userPassword: this.form.userPassword,
            };
            changePasswordRequest(params).then((res) => {
              this.dialogFormVisible = false
              this.$router.push('/')
              this.$message({
                message: "密码修改成功",
                type: "success",
              });
            });
          }
        }
      });
    },
    submit() {
      const params = {
        id: this.userInfo.userId,
        doctorName: this.name,
      };
      if (!this.name) {
        this.$message({
          message: "姓名不能为空！",
        });
        return;
      }
      settingName(params).then(() => {
        this.dialogVisible = false;
        getUserInfo(this.userInfo.userId).then((res) => {
          let result = res.data;
          this.$store.commit("SET_USER_INFO", result);
        });
        this.$message({
          message: "修改成功",
          type: "success",
        });
      });
    },
    handleClose() {
      this.dialogVisible = false;
    },
    settingNameFn() {
      console.log(this.userInfo);
      this.model = false;
      this.dialogVisible = true;
    },
    goUser() {
      this.$router.push("/user");
    },
    goIndex() {
      this.$router.push("/index");
    },
  },
};
</script>
<style lang="less">
.el-popover {
  min-width: 90px;
}
.popoverRow {
  text-align: center;
  cursor: pointer;
  margin-bottom: 10px;
}
.popoverRow :hover {
  color: rgba(2, 72, 167);
}
</style>
<style lang="less" scoped>
.img {
  width: 44px;
  height: 44px;
  cursor: pointer;
  img {
    width: 100%;
    height: 100%;
  }
}
</style>
